<template>
  <div class="total-info">
    <div v-for="(item, index) in totalList" :key="index" class="total-item">
      <el-popover placement="bottom-start" trigger="hover">
        <div class="total-name" slot="reference">
          <span>{{ item.name }}：</span>
          <el-tag type="danger" size="mini" class="m-r-2">{{ item.value || 0 }}</el-tag>
          <span>元</span>
          <el-tag v-if="index" type="success" size="mini" class="m-l-2"
            >({{ item.percent || 0 }}%)</el-tag
          >
        </div>
        <div class="total-cont">
          <TotalEcharts :data="item" />
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TotalEcharts: () => import('./total-echarts')
  },
  data() {
    return {
      defaultChartObj: {
        name: '',
        value: '',
        percent: ''
      },
      totalList: [
        {
          name: '成本总金额',
          value: '',
          percent: '',
          chartList: [
            {
              name: '原材料成本',
              value: '',
              percent: ''
            },
            {
              name: '加工成本',
              value: '',
              percent: ''
            },
            {
              name: '其他成本',
              value: '',
              percent: ''
            }
          ]
        },
        {
          name: '原材料成本',
          value: '',
          percent: '',
          chartList: [
            {
              name: '圆管',
              value: 4000,
              percent: '40%'
            },
            {
              name: '方管',
              value: 3000,
              percent: '30%'
            },
            {
              name: '矩管',
              value: 2000,
              percent: '20%'
            },
            {
              name: '六角棒',
              value: 1000,
              percent: '10%'
            }
          ]
        },
        {
          name: '加工成本',
          value: '',
          percent: '',
          chartList: [
            {
              name: '激光切管',
              value: 4000,
              percent: '40%'
            },
            {
              name: '抛光',
              value: 3000,
              percent: '30%'
            },
            {
              name: '喷粉',
              value: 2000,
              percent: '20%'
            },
            {
              name: '切割',
              value: 1000,
              percent: '10%'
            }
          ]
        },
        {
          name: '其他成本',
          value: '',
          percent: '',
          chartList: [
            {
              name: '包装费',
              value: 4000,
              percent: '40%'
            },
            {
              name: '物流费',
              value: 3000,
              percent: '30%'
            },
            {
              name: '搬运费',
              value: 2000,
              percent: '20%'
            },
            {
              name: '其他',
              value: 1000,
              percent: '10%'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    this.initTotalList()
  },
  methods: {
    // 初始化成本总金额
    initTotalList() {
      this.totalList.forEach((itemSt) => {
        let formData = this.detailData.formData
        // 成本总金额
        if (itemSt.name === '成本总金额') {
          itemSt.value = formData.cost_analysis_total || 0
          itemSt.percent = formData.cost_analysis_total_ratio || 0
          itemSt.chartList.forEach((itemNd) => {
            if (itemNd.name === '原材料成本') {
              itemNd.value = formData.cost_analysis_material
              itemNd.percent = formData.cost_analysis_material_ratio
            } else if (itemNd.name === '加工成本') {
              itemNd.value = formData.cost_analysis_process
              itemNd.percent = formData.cost_analysis_process_ratio
            } else if (itemNd.name === '其他成本') {
              itemNd.value = formData.cost_analysis_other
              itemNd.percent = formData.cost_analysis_other_ratio
            }
          })
        }

        // 原材料成本
        if (itemSt.name === '原材料成本') {
          itemSt.value = formData.cost_analysis_material || 0
          itemSt.percent = formData.cost_analysis_material_ratio || 0
          let dataList = this.detailData.table_1.map((itemNd) => {
            let obj = {
              name: itemNd.name || '空',
              value: itemNd.goods_amount || 0,
              percent: this.$XEUtils.divide(itemNd.goods_amount || 0, itemSt.value)
            }
            return obj
          })
          // dataList，如果name一样，合并value和percent的数据累加
          let chartList = []
          dataList.forEach((itemNd) => {
            let index = chartList.findIndex((itemSt) => itemSt.name === itemNd.name)
            if (index === -1) {
              chartList.push(itemNd)
            } else {
              chartList[index].value += itemNd.value
              chartList[index].percent = this.$XEUtils.divide(chartList[index].value, itemSt.value)
            }
          })
          chartList.forEach((itemNd) => {
            itemNd.percent = this.$util.getPercent(itemNd.percent)
          })
          itemSt.chartList = chartList
        }

        // 加工成本
        if (itemSt.name === '加工成本') {
          itemSt.value = formData.cost_analysis_process || 0
          itemSt.percent = formData.cost_analysis_process_ratio || 0
          let dataList = this.detailData.table_3.map((itemNd) => {
            let nameLast =
              itemNd.name_list.length > 0 ? itemNd.name_list[itemNd.name_list.length - 1] : '空'
            let valueHeji = this.$util.listFieldTotal(itemNd.list, 'goods_amount') || 0
            let obj = {
              name: nameLast,
              value: valueHeji,
              percent: this.$XEUtils.divide(valueHeji, itemSt.value)
            }
            return obj
          })
          // dataList，如果name一样，合并value和percent的数据累加
          // let chartList = []
          // dataList.forEach((itemNd) => {
          //   let index = chartList.findIndex((itemSt) => itemSt.name === itemNd.name)
          //   if (index === -1) {
          //     chartList.push(itemNd)
          //   } else {
          //     chartList[index].value += itemNd.value
          //     chartList[index].percent = this.$XEUtils.divide(chartList[index].value, itemSt.value)
          //   }
          // })
          // chartList.forEach((itemNd) => {
          //   itemNd.percent = this.$util.getPercent(itemNd.percent)
          // })
          itemSt.chartList = dataList
        }

        // 其他成本
        if (itemSt.name === '其他成本') {
          itemSt.value = formData.cost_analysis_other || 0
          itemSt.percent = formData.cost_analysis_other_ratio || 0
          let dataList = this.detailData.table_4.map((itemNd) => {
            let obj = {
              name: itemNd.name || '空',
              value: itemNd.goods_amount || 0,
              percent: this.$XEUtils.divide(itemNd.goods_amount || 0, itemSt.value)
            }
            return obj
          })
          // dataList，如果name一样，合并value和percent的数据累加
          let chartList = []
          dataList.forEach((itemNd) => {
            let index = chartList.findIndex((itemSt) => itemSt.name === itemNd.name)
            if (index === -1) {
              chartList.push(itemNd)
            } else {
              chartList[index].value += itemNd.value
              chartList[index].percent = this.$XEUtils.divide(chartList[index].value, itemSt.value)
            }
          })
          chartList.forEach((itemNd) => {
            itemNd.percent = this.$util.getPercent(itemNd.percent)
          })
          itemSt.chartList = chartList
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.total-info {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  .total-item {
    &:hover {
      .total-name {
        color: @colorWhite;
        background: #0099ff;
      }
    }
    .total-name {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 2px 5px;
      border-radius: 4px;
      margin-left: 10px;
    }
  }
}
</style>
